import {resetPasswordTypes} from "../../../actions/AuthActions/AuthActionsTypes/ResetPasswordActionsTypes";

const initState = {};

const SignInErrorReducer = (state = initState, action) => {
    switch (action.type) {
        case resetPasswordTypes.SET_ERROR: {
            return Object.assign({}, state, {
                [action.name]: action.message,
            });
        }

        case resetPasswordTypes.REMOVE_ERRORS: {
            return initState;
        }

        default: {
            return state;
        }
    }
};

export default SignInErrorReducer;
